import type { StackProps } from '@mui/material';
import { Stack, Typography } from '@mui/material';
import type { Currency } from '@weft/types';
import { Price } from 'apps/app/src/components/design/Price';
import React from 'react';

type DynamicInvoiceProductLineItemDetailProps = StackProps & {
  label: string;
  value: React.ReactNode;
  isPrice?: boolean;
  currency?: Currency;
};

export const DynamicInvoiceProductLineItemDetail: React.FC<DynamicInvoiceProductLineItemDetailProps> = ({
  label,
  value,
  isPrice = false,
  currency,
  ...props
}) => (
  <Stack
    direction="column"
    alignItems='flex-end'
    minWidth = '130px'
    {...props}
  >
    <Typography
      variant='body2'
      fontWeight={400}
      fontSize="14px"
      color='#1B3D5599'
    >
      {label}
    </Typography>
    {
      isPrice ? ( 
        <Price
          variant="h6"
          currency={currency}
        >
          {value}
        </Price> 
      ) : ( 
        <Typography
          variant="h6"
          sx={{ color: 'rgba(13, 27, 39, 0.87)' }}
        >
          {value}
        </Typography>)
    }
  </Stack>
);